import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatIconModule, MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { DeloitteAiLoadingIconComponent } from "./loading-icon";

@NgModule({
    declarations: [
        DeloitteAiLoadingIconComponent
    ],
    imports: [
        CommonModule,
        MatIconModule
    ],
    exports: [
        MatIconModule,
        DeloitteAiLoadingIconComponent
    ],
    providers: [],
})
export class DeloitteAiIconModule {

    public constructor(
        matIconRegistry: MatIconRegistry,
        domSanitizer: DomSanitizer
    ) {
        const icons: {[key: string]: SafeHtml} = {
            "deloitte-ai-download": domSanitizer.bypassSecurityTrustResourceUrl(`/assets/img/icons/download.svg`),
            "deloitte-ai-preview": domSanitizer.bypassSecurityTrustResourceUrl(`/assets/img/icons/preview.svg`),
            "deloitte-ai-minus": domSanitizer.bypassSecurityTrustResourceUrl(`/assets/img/icons/minus.svg`),
            "deloitte-ai-plus": domSanitizer.bypassSecurityTrustResourceUrl(`/assets/img/icons/plus.svg`),
            "deloitte-ai-plus-circle": domSanitizer.bypassSecurityTrustResourceUrl(`/assets/img/icons/plus.svg`),
            "deloitte-ai-add": domSanitizer.bypassSecurityTrustResourceUrl(`/assets/img/icons/add.svg`),
            "deloitte-ai-close-outline": domSanitizer.bypassSecurityTrustResourceUrl(`/assets/img/icons/close-outline.svg`),
            "deloitte-ai-accept-outline": domSanitizer.bypassSecurityTrustResourceUrl(`/assets/img/icons/accept-outline.svg`),
            "deloitte-ai-folder": domSanitizer.bypassSecurityTrustResourceUrl(`/assets/img/icons/folder.svg`),
            "deloitte-ai-edit-outline": domSanitizer.bypassSecurityTrustResourceUrl(`/assets/img/icons/edit-outline.svg`),
            "deloitte-ai-delete-outline": domSanitizer.bypassSecurityTrustResourceUrl(`/assets/img/icons/delete.svg`),
            "deloitte-ai-add-user": domSanitizer.bypassSecurityTrustResourceUrl(`/assets/img/icons/add-user.svg`),
            "deloitte-ai-add-api-key": domSanitizer.bypassSecurityTrustResourceUrl(`/assets/img/icons/add-api-key.svg`),
            "deloitte-ai-refresh": domSanitizer.bypassSecurityTrustResourceUrl(`/assets/img/icons/refresh.svg`),
            "deloitte-ai-arrow-left": domSanitizer.bypassSecurityTrustResourceUrl(`/assets/img/icons/arrow_left.svg`),
            "deloitte-ai-arrow-right": domSanitizer.bypassSecurityTrustResourceUrl(`/assets/img/icons/arrow_right.svg`),
            "deloitte-ai-idea": domSanitizer.bypassSecurityTrustResourceUrl(`/assets/img/icons/idea.svg`),
            "deloitte-ai-exclamation-mark": domSanitizer.bypassSecurityTrustResourceUrl(`/assets/img/icons/exclamation-mark.svg`),
            "deloitte-ai-question": domSanitizer.bypassSecurityTrustResourceUrl(`/assets/img/icons/info-question.svg`),
            "deloitte-ai-tooltip": domSanitizer.bypassSecurityTrustResourceUrl(`/assets/img/icons/tooltip.svg`),
        };

        Object.keys(icons).forEach((key) => matIconRegistry.addSvgIcon(key, icons[key]));
    }
}

